import { render } from "./Manager.vue?vue&type=template&id=4805d52f&scoped=true"
import script from "./Manager.vue?vue&type=script&lang=js"
export * from "./Manager.vue?vue&type=script&lang=js"

import "./Manager.vue?vue&type=style&index=0&id=4805d52f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4805d52f"]])

export default __exports__